// extracted by mini-css-extract-plugin
module.exports = {"backButton__icon":"BackButton_backButton__icon__1fSbU"};